// extracted by mini-css-extract-plugin
export var parcelRow = "_te-0";